import { render, staticRenderFns } from "./wkSelect.vue?vue&type=template&id=062dc7de&scoped=true"
import script from "./wkSelect.vue?vue&type=script&lang=js"
export * from "./wkSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062dc7de",
  null
  
)

export default component.exports